interface PriceListState {
  prices: any[]; // ideally replace `any` with a proper type
  loading: boolean;
}
const initialState: PriceListState = {
  prices: [],
  loading: false
};

export default function priceList(state = initialState, action: any) : PriceListState{
  console.log("priceList reducer action:", action);
  console.log("priceList reducer state:", state);
  switch (action.type) {
    case 'RECEIVE_PRICE_LIST':
      return {
        ...state,
        prices: action.prices,
        loading: action.loading
      };   
    default:
      return state;
  }
}